import { React, useState, useRef } from "react";
const MarketAnalysisToss = ({tossData}) => {
    

    return (
      <div style={{ marginTop: "10px" }}>
        <style>
          {`


.table-box-body {
  background-color: white; 
}
.bg-gray, .Bl_NT_DB_LITE, .table-box-body, tabcontent {
   background-color: white;
}
        `}{" "}
        </style>
        <div className="table-box-body" style={{ display: "block" }}>
          <div style={{ marginTop: "20px", display: "block" }}>
            <div className="table-box-body">
              <div
                className="card card-accent-danger"
                style={{ marginBottom: "0px" }}
              >
                <div className="row bg-gray-100 market-head site_family">
                  <div className="col-12">
                    <strong>Toss</strong>
                  </div>
                </div>
              </div>
              <div
                class="market-runners"
                style={{
                  borderLeft: "solid 1px #808080",
                  borderRight: "solid 1px #808080",
                  borderBottom: "solid 1px #808080"
                }}
              >
                <div>
                  {tossData !== null &&
                    tossData !== undefined &&
                    tossData !== "" &&
                    tossData.map((toss) => (
                      <div class="row runners">
                        <div
                          class="col-7 col-md-4"
                          style={{ paddingTop: "3px" }}
                        >
                          <strong
                            style={{ fontSize: "1rem" }}
                            className="site_family"
                          >
                            {toss.market}
                          </strong>{" "}
                          <br />{" "}
                          <span>
                            <span class="position-plus site_family">
                              <strong> Full Book</strong>
                            </span>{" "}
                          </span>{" "}
                        </div>{" "}
                        <div class="col-5 col-md-8 price">
                          <div class="row">
                            <div class="col-md-2 d-none d-md-block cta-back">
                              <div
                                id="b3-54600"
                                class="col-12 price site_family"
                              >
                                {" "}
                              </div>{" "}
                              <div
                                id="bs3-54600"
                                class="col-12 size site_family"
                              >
                                {" "}
                              </div>
                            </div>{" "}
                            <div class="col-md-2 d-none d-md-block cta-back">
                              <div
                                id="b2-54600"
                                class="col-md-12 col-sm-12 price site_family"
                              >
                                {" "}
                              </div>{" "}
                              <div
                                id="bs2-54600"
                                class="col-md-12 col-sm-12 size site_family"
                              >
                                {" "}
                              </div>
                            </div>{" "}
                            <div class="col-6 col-md-2 cta-back">
                              <div
                                class="col-12 price site_family"
                                style={{
                                  backgroundColor: "rgb(227, 248, 255)"
                                }}
                              >
                                {toss.lay}
                              </div>{" "}
                              <div
                                id="bs1-54600"
                                class="col-12 size site_family"
                                style={{
                                  backgroundColor: "rgb(227, 248, 255)"
                                }}
                              >
                                {toss.layrate}
                              </div>
                            </div>{" "}
                            <div class="col-6 col-md-2 cta-lay">
                              <div
                                id="l1-54600"
                                class="col-md-12 col-sm-12 price site_family"
                                style={{
                                  backgroundColor: "rgb(255, 205, 204)"
                                }}
                              >
                                {toss.back}
                              </div>
                              <div
                                id="ls1-54600"
                                class="col-md-12 col-sm-12 size site_family"
                                style={{
                                  backgroundColor: "rgb(255, 205, 204)"
                                }}
                              >
                                {toss.backrate}
                              </div>
                            </div>{" "}
                            <div class="col-md-2 d-none d-md-block cta-lay">
                              <div
                                id="l2-54600"
                                class="col-md-12 col-sm-12 price site_family"
                              >
                                {" "}
                              </div>{" "}
                              <div
                                id="ls2-54600"
                                class="col-md-12 col-sm-12 size site_family"
                              >
                                {" "}
                              </div>
                            </div>{" "}
                            <div class="col-md-2 d-none d-md-block cta-lay">
                              <div
                                id="l3-54600"
                                class="col-md-12 col-sm-12 price site_family"
                              >
                                {" "}
                              </div>{" "}
                              <div
                                id="ls3-54600"
                                class="col-md-12 col-sm-12 size site_family"
                              >
                                {" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

}

export default MarketAnalysisToss;